import {Component, Input} from '@angular/core';
import {KeyValue} from '@angular/common';

@Component({
    selector: 'app-prd-properties',
    templateUrl: './prd-properties.component.html',
    standalone: false
})
export class PrdPropertiesComponent {
    @Input() propertyOrder: { [key: string]: number } = {};
    @Input() properties: ReadonlyMap<string, string> = new Map();
    @Input() propertyStyle: { [key: string]: string } = {};

    propertyNames: { [key: string]: string } = {
        operationalStatus: 'Operationele project status',
        start: 'Start bouw',
        end: 'Opleverdatum',
        clientName: 'Opdrachtgever',
        numberOfHousingUnits: 'Aantal woningen',
    };

    compareFn = (a: KeyValue<string, any>, b: KeyValue<string, any>): number => {
        return (this.propertyOrder[a.key] || 99999) - (this.propertyOrder[b.key] || 99999);
    }
}
